import { gql } from '@apollo/client'

export type QueryVars = {
  userId: string
  customerId: string
}

export type NextApplicantResponse = {
  subjectId: string | null
}

export type Response = {
  getNextApplicant: NextApplicantResponse
}

const query = gql`
  query ($userId: String!, $customerId: String!) {
    getNextApplicant(userId: $userId, customerId: $customerId) {
      subjectId
    }
  }
`

export default query
